import Segment from 'helpers/segment';

export const TRACKING_IDS = {
  CALENDAR_SAVED: 'Calendar Saved',
  CALENDAR_REMOVED: 'Calendar Removed',
  SAVE_ICAL_URL: 'Save iCal Url',
  DELETE_ICAL_URL: 'Delete iCal Url',
  LEARN_MORE_LINK: 'Learn More Link',
  ADD_PRACTITIONER_LINK: 'Add Practitioner Link',
  TUTORIAL_MODAL_LINK: 'Tutorial Modal Viewed',
};

export const flowTracker = Segment.makeFlowTracker('Calendar Sync');
